export default {
  clientTours: '/properties/tours',
};
